import { useEffect } from 'react';
import {
  Box,
  HStack,
  VStack,
  Text,
  Image,
  useDisclosure,
} from '@chakra-ui/react';
import { Handle, NodeProps, Position, useReactFlow, Node } from 'reactflow';
import { useParams } from 'react-router-dom';

import ReceiverNodeIcon from '../../../../assets/projects/receiver_node.svg';
import { ReceivedNodeData } from '../../models';
import { ReceiverNodeEditorModal } from '.';
import { NODE_SIZE } from '../../../../constants';

export const ReceiverNode = ({
  data: {
    receivedRoles,
    receivedUsers,
    hasRejection,
    durationUnit,
    durationValue,
  },
  id,
}: NodeProps<ReceivedNodeData>) => {
  const {
    isOpen: isReceiverNodeEditorModalOpen,
    onOpen: onReceiverNodeEditorModalOpen,
    onClose: onReceiverNodeEditorModalClose,
  } = useDisclosure();

  const reactFlow = useReactFlow();
  const { projectId } = useParams();

  useEffect(() => {}, [receivedRoles, receivedUsers]);

  return (
    <Box bg="white" onClick={onReceiverNodeEditorModalOpen}>
      {isReceiverNodeEditorModalOpen && (
        <ReceiverNodeEditorModal
          isOpen={isReceiverNodeEditorModalOpen}
          onClose={newData => {
            onReceiverNodeEditorModalClose();

            if (newData) {
              reactFlow.setNodes((prevNodes: Node<ReceivedNodeData>[] = []) =>
                prevNodes.map(node => {
                  if (node.id === id) {
                    return {
                      ...node,
                      data: {
                        ...node.data,
                        ...newData,
                      },
                    };
                  }
                  return node;
                })
              );
            }
          }}
          receivedNodeData={{
            receivedRoles,
            receivedUsers,
            hasRejection,
            durationUnit,
            durationValue,
          }}
          projectId={String(projectId)}
        />
      )}

      <Handle
        type="target"
        position={Position.Top}
        id="a"
        style={{ width: NODE_SIZE, height: NODE_SIZE }}
      />

      <VStack
        w="48"
        h="20"
        border="1px"
        borderColor="custom_purple.1"
        borderRadius="md"
        gap="0"
      >
        <HStack
          bg="custom_purple.1"
          color="white"
          w="full"
          justify="center"
          flex="1"
        >
          <Image src={ReceiverNodeIcon} />
          <Text fontSize="xs" fontWeight="semibold">
            Receiver Node
          </Text>
        </HStack>

        <HStack flex="1" maxW="48">
          <Box
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            px="3"
          >
            {receivedRoles
              .map(role => role.name)
              .concat(receivedUsers.map(user => user.firstName))
              .map((name, index, arr) => (
                <Text as={'span'} key={name} fontSize="sm">
                  {name}
                  {index < arr.length - 1 && arr.length !== 1 && ', '}
                </Text>
              ))}
          </Box>
        </HStack>
      </VStack>

      <Handle
        type="source"
        position={Position.Bottom}
        id="b"
        style={{ width: NODE_SIZE, height: NODE_SIZE }}
      />
    </Box>
  );
};
